import { Injectable } from '@angular/core';
import { createAction, props } from '@ngrx/store';

@Injectable({
    providedIn: 'root' // No need to provide in AppModule, and now tree shakable
})
export class AppointmentResourceSettingsActions {
    static getAppointmentResources = createAction('[Reminders:Resources] Get Appointment Resources', props<{ userid: any}>());

    static getAppointmentResourcesSuccess = createAction('[Reminders:Resources] Get Appointment Resources Success',
        props<{ payload: any }>());

    static getAppointmentResourcesFail = createAction('[Reminders:Resources] Get Appointment Resources Fail',
        props<{ error: any }>());

    static saveAppointmentResourceStrategyMappingSuccess = createAction(
        '[Reminders:Resources] Save Appointment Resource Strategy Mapping Success',
        props<{ payload: any }>());

    static saveAppointmentResourceStrategyMappingFail = createAction(
        '[Reminders:Resources] Save Appointment Resource Strategy Mapping Fail',
        props<{ error: any, resourceId: any, strategyId: any }>());

    static openConfirmDialog = createAction(
        '[Reminders:Resources] Open Confirm Dialog',
        props<{dialogMessage: string, resourceId: any, strategyId: any, okLabel: string, cancelLabel: string}>()
    );

    static openConfirmDialogCancel = createAction(
        '[Reminders:Resources] Open Confirm Dialog Cancelled');

    static attemptSaveResourcesStrategyMapping = createAction('[Reminders:Resources] Attempt Save Resource Strategy Mapping',
        props <{resourceId: number, strategyId: any}>());

    static saveResourcesStrategyMapping = createAction('[Reminders:Resources] Save Resource Strategy Mapping',
        props <{resourceId: number, strategyId: any}>());

    static getAppointmentResourcesAndResources = createAction('[Adaptive:Resources] Get AppointmentResources And Resources ', props<{ userid: any}>());
}
